import React from "react";
import { connect } from "react-redux";

class OpenPayModal extends React.Component {
    render() {
        const { onClick = () => { },DepositPayments } = this.props
        return (
            <>
                <div className='openPayModal'>
                    <div className='openPayModalCenter'>
                        <div className='openPayModalTitle'>Gửi Tiền</div>
                        <div className="openPayModalBody">
                            Giao dịch {DepositPayments.transactionId || ""} đã được tạo thành công.
                            Bằng cách nhấn " Đã Hiểu", bạn sẽ tiếp tục quá trình gửi tiền tại một cửa sổ mới.
                        </div>
                        <div className="openPayModalBtn" onClick={onClick}>Đã Hiểu</div>
                    </div>
                </div>
            </>
        )
    }
}
const mapStateToProps = state => ({
    DepositPayments: state.DepositPayments,
});
const mapDispatchToProps = {
};
export default connect(mapStateToProps, mapDispatchToProps)(OpenPayModal);

